<fr-table [config]="tableConfig" [data]="users" Id="users-table" [paginatorConfig]="paginatorConfig">
  <div above-table-body-space>
    <app-loading-spinner *ngIf="!users"></app-loading-spinner>
  </div>
</fr-table>
